<div class="flex gap-8 mb-3">
	<div class="relative">
		<div
			class="action-icons"
			(click)="toggleShowContactInfo()"
			[testHook]="testHooks.ToggleShowContactInfoDiv"
		>
			<app-icon
				[icon]="ICON.ADDRESS_CARD"
				class="text-green text-xl"
				[testHook]="testHooks.AddressCardIcon"
			></app-icon>
			<p class="text-sm">View contact info</p>
		</div>
	</div>
	<div
		class="flex flex-col items-center cursor-pointer hover:text-red hover:underline"
		(click)="cancel()"
		*ngIf="showCancel"
		[testHook]="testHooks.CancelDiv"
	>
		<app-icon
			[icon]="ICON.CANCEL"
			class="text-red text-xl"
			[testHook]="testHooks.CancelIcon"
		></app-icon>
		<p class="text-sm">{{ cancelLabel }}</p>
	</div>
	<ng-container
		*ngIf="!completedOrder && propertyUsage === usageType.RESIDENTIAL"
	>
		<a
			externalNavInterceptor
			[href]="quoteLink"
			target="_blank"
			class="flex flex-col items-center cursor-pointer hover:text-orange hover:underline"
			*ngIf="provider !== titleInsuranceProvider.FCT"
			[testHook]="testHooks.Link1"
		>
			<app-icon
				[icon]="ICON.INTEGRATED"
				class="text-orange text-xl"
				[testHook]="testHooks.IntegratedIcon"
			></app-icon>
			<p class="text-sm">{{ quoteLabel }}</p>
		</a>
		<div
			class="flex flex-col items-center cursor-pointer hover:text-orange hover:underline"
			*ngIf="provider === titleInsuranceProvider.FCT"
			(click)="openPortal()"
			[testHook]="testHooks.OpenPortalDiv"
		>
			<app-icon
				[icon]="ICON.INTEGRATED"
				class="text-orange text-xl"
				[testHook]="testHooks.IntegratedIcon1"
			></app-icon>
			<p class="text-sm">{{ quoteLabel }}</p>
		</div>
	</ng-container>
	<ng-container
		*ngIf="
			provider !== titleInsuranceProvider.MANUAL &&
			propertyUsage === usageType.RESIDENTIAL
		"
	>
		<div
			*ngIf="orderValid"
			class="action-icons"
			(click)="openPortal()"
			[testHook]="testHooks.OpenPortalDiv1"
		>
			<app-icon
				[icon]="submitIcon"
				class="text-green text-xl"
				[testHook]="testHooks.SubmitIcon"
			></app-icon>
			<p class="text-sm">{{ submitOrderText }}</p>
		</div>
		<div
			*ngIf="!orderValid"
			class="flex flex-col items-center cursor-not-allowed"
			matTooltip="Complete the required missing fields before returning to the portal"
		>
			<app-icon
				[icon]="submitIcon"
				class="text-gray-400 text-xl"
				[testHook]="testHooks.SubmitIcon1"
			></app-icon>
			<p class="text-gray-400 text-sm">{{ submitOrderText }}</p>
		</div>
	</ng-container>
	<div
		*ngIf="completedOrder"
		class="border-l border-grey-veryLight pl-8 action-icons"
		(click)="openFinancialSettings()"
		[testHook]="testHooks.OpenFinancialSettingsDiv"
	>
		<app-icon
			[icon]="ICON.DOLLAR"
			class="text-green text-xl"
			[testHook]="testHooks.DollarIcon"
		></app-icon>
		<p class="text-sm">Finance settings</p>
	</div>
	<div
		*ngIf="!completedOrder"
		class="border-l border-grey-veryLight pl-8 flex items-center gap-2"
	>
		<app-icon
			[icon]="ICON.HOME"
			class="text-green text-2xl"
			[testHook]="testHooks.HomeIcon"
		></app-icon>
		<div>
			<div class="flex items-end gap-2">
				<div>
					<p class="text-gray text-sm">Property type</p>
					<p class="font-bold">{{ propertyTypeString$ | async }}</p>
				</div>
				<app-anchor
					[icon]="ICON.EDIT"
					[url]="propertyUrl"
					[queryParams]="backUrlParams"
					type="static"
					[testHook]="testHooks.Link"
				></app-anchor>
			</div>
		</div>
	</div>

	@if (!completedOrder) {
		<div class="border-l border-grey-veryLight pl-8 flex items-center">
			<app-title-insurance-price-override />
		</div>
	}
</div>
